import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'components/Modal';
import { IconX, IconUser } from '@tabler/icons-react';
import axios from 'axios';
import Skeleton from 'react-loading-skeleton';

import CardOurClassImage from 'components/CardOurClassImage';

import { AgeDefault } from 'lib/DefaultData';
import { API_URL } from 'lib/network/api';

const ModalViewClass = ({ item, openModal, setOpenModal }) => {
  const [thumbnailUrl, setThumbnailUrl] = useState('');
  const [loadingImage, setLoadingImage] = useState(true);

  const goToCheckout = () => {
    console.log('checkout');
  };

  const findAge = (paramsAge) => {
    const age = AgeDefault.find((item) => item.value === paramsAge);
    return `${age.name} ${age.description}`;
  };

  const getThumbnail = async (imagePath) => {
    try {
      const cacheBuster = new Date().getTime();
      const res = await axios.get(`${API_URL}/file?file_path=${imagePath}&_=${cacheBuster}`, {
        responseType: 'arraybuffer',
      });

      if (!res.headers['content-type'].startsWith('image')) {
        throw new Error('Invalid content type');
      }

      const arrayBufferView = new Uint8Array(res.data);
      const blob = new Blob([arrayBufferView], { type: res.headers['content-type'] });
      const imageUrl = URL.createObjectURL(blob);

      return imageUrl;
    } catch (error) {
      console.error('Failed to load image:', error);
      return '/kin/assest/image/icon-profile.png';
    }
  };

  // Fetch thumbnail saat modal dibuka atau item berubah
  useEffect(() => {
    if (!item?.thumbnail) return;
    let isMounted = true;

    const fetchThumbnail = async () => {
      setLoadingImage(true);
      const url = await getThumbnail(item.thumbnail);
      if (isMounted) {
        setThumbnailUrl(url);
        setLoadingImage(false);
      }
    };

    fetchThumbnail();

    return () => {
      isMounted = false;
    };
  }, [item]);

  return (
    <Modal open={openModal} onRequestClose={() => setOpenModal(false)} clickOverlay={true}>
      <div className="bg-white rounded-2xl min-w-md w-96 relative text-kin-text flex flex-col gap-3 pt-2 pb-5">
        {/* Tombol Close */}
        <button
          type="button"
          onClick={() => setOpenModal(false)}
          className="absolute top-2 right-2 p-2 z-10">
          <IconX className="w-6 h-6" />
        </button>

        {/* Gambar + Skeleton */}
        <div className="relative px-2 w-full flex gap-2 snap-x snap-mandatory overflow-x-auto z-0">
          <CardOurClassImage item={item} variant="modal" />
        </div>

        {/* Konten Detail */}
        <div className="px-5 flex flex-col gap-3">
          <div>
            <span className="mt-4 text-sm font-light">{item.subject}</span>
            <h3 className="text-lg font-bold leading-none">{item.name}</h3>
            <span className="text-base font-semibold">{item.theme}</span>
          </div>

          {/* Deskripsi */}
          <div className="mt-2 max-h-[115px] overflow-hidden line-clamp-[8]">
            <div
              className="text-xs font-medium"
              dangerouslySetInnerHTML={{ __html: item.description }}
            />
          </div>

          {/* Informasi Tambahan */}
          <div className="bg-[#F3F2F0] py-2.5 px-3 rounded-lg">
            <ul className="flex flex-col gap-1">
              <li className="flex flex-row items-center font-normal gap-2">
                <div className="w-4 h-4 relative">
                  <img
                    alt="icon-star"
                    src="/kin/assest/image/icon-star.svg"
                    className="absolute inset-0 h-full w-full object-cover"
                  />
                </div>
                <span className="text-sm">{item?.age_group ? findAge(item?.age_group) : '-'}</span>
              </li>
              <li className="flex flex-row items-center font-normal gap-2">
                <IconUser className="w-4 h-4" />
                <span className="text-sm">Ms. Rika</span>
              </li>
              <li className="flex flex-row items-center font-normal gap-2">
                <div className="w-4 h-4 relative">
                  <img
                    alt="icon-clock"
                    src="/kin/assest/image/icon-clock.svg"
                    className="absolute inset-0 h-full w-full object-cover"
                  />
                </div>
                <span className="text-sm">
                  {item?.duration ? `${item.duration} mins` : '- mins'}
                </span>
              </li>
            </ul>
          </div>

          {/* What to Expect */}
          <div>
            <span className="uppercase text-sm font-normal">What you will experience</span>
            <span className="font-normal gap-1 text-kin-text text-xs block">
              {item?.what_to_expect ? item?.what_to_expect : '-'}
            </span>
          </div>

          {/* Tombol Buy */}
          {/* <button
            onClick={() => goToCheckout()}
            className="bg-primary-main w-max text-white rounded-[100px] py-2 px-3 flex justify-center items-center">
            <span className="text-xs font-semibold block">BUY NOW</span>
          </button> */}
        </div>
      </div>
    </Modal>
  );
};

export default ModalViewClass;
